"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlledCheckboxField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_component_library_1 = require("@esub-engineering/react-component-library");
var react_hook_form_1 = require("react-hook-form");
exports.ControlledCheckboxField = react_1.default.memo(function (_a) {
    var control = _a.control, onChange = _a.onChange, rest = __rest(_a, ["control", "onChange"]);
    var _b = (0, react_hook_form_1.useController)({
        name: rest.name,
        control: control,
        defaultValue: false,
    }).field, ref = _b.ref, fieldValue = _b.value, fieldOnChange = _b.onChange, inputProps = __rest(_b, ["ref", "value", "onChange"]);
    // TODO: cover an invalid case for checkbox
    // const validationProps = {
    //   error: invalid,
    //   helperText: invalid ?? 'Required',
    // };
    return ((0, jsx_runtime_1.jsx)(react_component_library_1.Checkbox, __assign({}, rest, inputProps, { checked: fieldValue === true, onChange: function (event) {
            // have to call both... if you want to take action onChange from a component level
            // TODO: any way to forward this?
            if (onChange)
                onChange(event, event.target.checked);
            fieldOnChange(event);
        } })));
});
